import React from 'react'
import PropTypes from 'prop-types'
import { Platforms } from '../../actions/toolbar'

const stateProps = {
  'webrtcConnection.accessState': PropTypes.string.isRequired,
  'signaling.agentDetails.platformType': PropTypes.string,
  'ondemand.screenSharing': PropTypes.bool.isRequired,
  'ondemand.streamNotStarted': PropTypes.bool.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  webrtcConnection: { accessState },
  signaling: { agentDetails: { platformType } },
  ondemand: { screenSharing },
}) => {
  const platform = Object.values(Platforms).includes(platformType)
    ? platformType
    : 'windows'
  return (platform === Platforms.IOS) && (accessState === 'ACCESS_GRANTED') && !screenSharing
}

/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({
  state: { ondemand: { streamNotStarted } },
  translate,
}) => {
  let title = null
  let body = null
  let note = null
  if (streamNotStarted) {
    title = 'ovl-screen-sharing-inactive-title'
    body = <p dangerouslySetInnerHTML={{ __html: translate('ovl-screen-sharing-inactive-text') }} ></p>
    note = <>
      <p>
        {translate('ovl-screen-sharing-inactive-infos')}
      </p>
      <ul>
        <li dangerouslySetInnerHTML={{ __html: translate('ovl-screen-sharing-stop-info1') }} ></li>
        <li dangerouslySetInnerHTML={{ __html: translate('ovl-screen-sharing-stop-info2') }} ></li>
      </ul>
    </>
  } else {
    title = 'ovl-screen-sharing-stop-title'
    body = <p>{translate('ovl-screen-sharing-stop-text')}</p>
    note = <>
      <p>
        {translate('ovl-screen-sharing-stop-infos')}
      </p>
      <ul>
        <li dangerouslySetInnerHTML={{ __html: translate('ovl-screen-sharing-stop-info1') }} ></li>
        <li dangerouslySetInnerHTML={{ __html: translate('ovl-screen-sharing-stop-info2') }} ></li>
      </ul>
    </>
  }
  return {
    className: 'ios-not-sharing',
    iconClass: 'modal-icon-screen-not-sharing',
    title,
    body,
    note,
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
